import { z } from 'zod';
import { MetricValueSchema } from './analytics.js';
/**
 * Scheduled board/operating reports.
 *
 * A report is a persisted SNAPSHOT of metric values at generation time —
 * every figure carries its full lineage (numerator, denominator, timeframe,
 * exclusions, source) and its own freshness, and the UI drills through from
 * any figure to the filtered operational list behind it. A report never
 * recomputes on read: what the board saw is what is stored.
 */
export const REPORT_KINDS = ['board_monthly', 'operating_weekly'];
export const ReportKindSchema = z.enum(REPORT_KINDS);
export const ReportSectionSchema = z.object({
    title: z.string(),
    narrative: z.string().nullable(),
    metrics: z.array(MetricValueSchema),
});
export const ReportSchema = z.object({
    id: z.uuid(),
    kind: ReportKindSchema,
    title: z.string(),
    periodStart: z.iso.datetime(),
    periodEnd: z.iso.datetime(),
    generatedAt: z.iso.datetime(),
    generatedBy: z.enum(['schedule', 'manual']),
    sections: z.array(ReportSectionSchema),
    /** True when any section metric was computed from incomplete sources. */
    hasIncompleteSources: z.boolean(),
});
export const ReportListItemSchema = ReportSchema.omit({ sections: true });
export const ReportListResponseSchema = z.object({
    items: z.array(ReportListItemSchema),
    total: z.number().int(),
});
//# sourceMappingURL=reports.js.map